var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41a5ed",
    d: "M128 34.2H29.6V10.3c0-3.2 2.6-5.8 5.8-5.8h86.7c3.2 0 5.8 2.6 5.8 5.8v23.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c7bd5",
    d: "M29.6 34.2H128V64H29.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#195abe",
    d: "M29.6 64H128v29.8H29.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#103e91",
    d: "M122.2 123.5H35.5c-3.2 0-5.8-2.6-5.8-5.8V93.8H128v23.9c0 3.2-2.6 5.8-5.8 5.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2166c3",
    d: "M59.5 96.5h-53C3 96.5.1 93.6.1 90.1V37.9c0-3.5 2.9-6.4 6.4-6.4h53c3.5 0 6.4 2.9 6.4 6.4v52.2c0 3.5-2.8 6.4-6.4 6.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.3 82.4l-8.9-35.9h7.1L21 62.8c.9 4.4 1.8 8.9 2.4 12.5h.1c.6-3.8 1.6-8 2.6-12.6L30 46.5h7L40.6 63c.9 4.3 1.7 8.2 2.2 12.1h.1c.6-4 1.5-8 2.5-12.4l3.8-16.2H56l-9.8 35.9H39l-3.8-16.9c-.9-4-1.6-7.4-2.1-11.3H33c-.6 3.8-1.3 7.3-2.4 11.4l-4.2 16.9h-7.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9 37.3V90.1c0 3.5-2.9 6.4-6.4 6.4H29.7v5.7h35.2c3.5 0 6.4-2.9 6.4-6.4V43.6c0-3.2-2.3-5.9-5.4-6.3z",
    opacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.8459eb0a.svg";
export { ForwardRef as ReactComponent };